import { config } from '../config'

export async function findAddress(addressParam, countryCode) {
  const response = await fetch(
    `${config.apiEndpoint}/v1/destinations/address/search?query=${addressParam}&country=${countryCode}`,
    {
      method: 'GET',
    }
  )

  return response.json()
}

export async function formatAddress(format) {
  const formatUrl = new URL(format)

  const response = await fetch(
    `${config.apiEndpoint}/v1/destinations/address/format${formatUrl.search}`,
    {
      method: 'GET',
    }
  )

  return response.json()
}
